import { render, staticRenderFns } from "./JacketCertificationBadges.vue?vue&type=template&id=77b6660f&scoped=true"
import script from "./JacketCertificationBadges.vue?vue&type=script&lang=js"
export * from "./JacketCertificationBadges.vue?vue&type=script&lang=js"
import style0 from "./JacketCertificationBadges.vue?vue&type=style&index=0&id=77b6660f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b6660f",
  null
  
)

export default component.exports